<script setup>
defineProps(['model'])
</script>

<template>
  <div class="inline-block">
    <NuxtLink
      :to="useCmsUrl(model.url?.value)"
      class="flex flex-col justify-between w-24 max-w-24 h-full gap-5 mx-auto"
    >
      <div class="flex justify-center items-center h-24 w-full">
        <NuxtImg
          v-if="model.aprimoImage?.url"
          provider="fastlyAprimo"
          class="w-24 max-h-24 object-contain"
          :src="model.aprimoImage.url"
          :alt="model.imageAltText?.value"
        />
      </div>
      <div class="font-semibold underline text-center min-h-12">
        {{ model.title?.value }}
      </div>
    </NuxtLink>
  </div>
</template>
